module.exports = __webpack_public_path__ + "img/arrow_full_down.f78829fd.svg";